import { FormattedNumber, FormattedMessage } from 'react-intl';


export default function formatMessageWithDealInfo(message, dealInfo) {
  const values = {
    price: <FormattedNumber value={dealInfo.price}
                            style="currency"
                            currency={dealInfo.currency} />,
  };

  return (
    <FormattedMessage {...message}
                      values={values} />
  );
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/_format-message-with-deal-info.js